import { post } from './request'

export function deviceAdd(data) {
  return post('/api/Device/Add', data)
}

export function deviceUpdate(data) {
  return post('/api/Device/Update', data)
}

export function deviceList(data) {
  return post('/api/Device/List', data)
}

export function deviceDetail(data) {
  return post('/api/Device/Detail', data)
}

export function deviceDelete(data) {
  return post('/api/Device/Delete', data)
}

export function deviceOnlineFloorStats(data) {
  return post('/api/Device/OnlineFloorStats', data)
}

export function deviceLocationTrackList(data) {
  return post('/api/Device/LocationTrack/List', data)
}

export function deviceOnlineRecordDates(data) {
  return post('/api/Device/OnlineRecord/Dates', data)
}

export function deviceOnlineRecordList(data) {
  return post('/api/Device/OnlineRecord/List', data)
}

export function deviceOnlineRecordDevices(data) {
  return post('/api/Device/OnlineRecord/Devices', data)
}

export function deviceLocationTrackDwellStats(data) {
  return post('/api/Device/LocationTrack/DwellStats', data)
}

export function deviceOnlineRecordExceedDwell(data) {
  return post('/api/Device/OnlineRecord/ExceedDwell', data)
}

export function deviceOnlineRecordBaseStationDwellList(data) {
  return post('/api/Device/OnlineRecord/BaseStationDwellList', data)
}

export function deviceOnlineRecordJobTypeStats(data) {
  return post('/api/Device/OnlineRecord/JobTypeStats', data)
}

export function deviceOnlineRecordJobTypeBaseStationDwellList(data) {
  return post('/api/Device/OnlineRecord/JobTypeBaseStationDwellList', data)
}

export function deviceOnlineRecordBaseStationList(data) {
  return post('/api/Device/OnlineRecord/BaseStationList', data)
}

/** multipart 批量导入设备，字段名 file */
export function deviceImport(file) {
  const fd = new FormData()
  fd.append('file', file)
  return post('/api/Device/Import', fd, { timeout: 120000 })
}
